import { memo } from 'react'
import { safeSheetOpenHaptic } from '../lib/safeTelegram'

const TABS = [
  { id: 'gifts', label: 'Главная' },
  { id: 'earn', label: 'Заработать' },
  { id: 'profile', label: 'Профиль' },
]

const ICONS = {
  gifts: { active: '/images/icons/figma/nav-home-active.svg', inactive: '/images/icons/figma/nav-home-inactive.svg' },
  earn: { active: '/images/icons/figma/nav-earn-active.svg', inactive: '/images/icons/figma/nav-earn-inactive.svg' },
  profile: { active: '/images/icons/figma/nav-profile-active.svg', inactive: '/images/icons/figma/nav-profile-inactive.svg' },
}

function NavBar({ activeTab, onChange }) {
  return (
    <nav
      className="fixed bottom-[calc(1.75rem+env(safe-area-inset-bottom))] left-1/2 -translate-x-1/2 z-[9999] flex h-16 w-[250px] items-center gap-3 rounded-full border border-[rgba(250,250,255,0.1)] px-4 py-2 backdrop-blur-[6px] overflow-visible"
      style={{
        background: 'linear-gradient(90deg, rgba(250, 250, 255, 0.05) 0%, rgba(250, 250, 255, 0.05) 100%), linear-gradient(90deg, rgba(8, 8, 10, 0.9) 0%, rgba(8, 8, 10, 0.9) 100%)'
      }}
      aria-label="Навигація"
    >
      {TABS.map(({ id, label }) => {
        const isActive = activeTab === id

        return (
          <button
            key={id}
            type="button"
            onClick={() => {
              safeSheetOpenHaptic()
              onChange(id)
            }}
            className={`relative flex h-12 w-16 shrink-0 flex-col items-center justify-center gap-1 text-[12px] font-[510] leading-[14px] tracking-[-0.01em] transition-colors duration-200 ${isActive ? 'text-[#007CFF]' : 'text-[rgba(250,250,255,0.5)]'}`}
            aria-current={isActive ? 'page' : undefined}
          >
            <img loading="eager" src={ICONS[id][isActive ? 'active' : 'inactive']} alt="" width="28" height="28" className="relative z-[1] h-7 w-7" aria-hidden="true" />
            <span className="relative z-[1] whitespace-nowrap">{label}</span>
          </button>
        )
      })}
    </nav>
  )
}

export default memo(NavBar)
